import {PublicPageQueryResultSocialMediaAccount} from '../graphql/queries/LinkpopQuery';

export const enabledSocialPlatforms = [
  'shop',
  'email',
  'facebook',
  'instagram',
  'twitter',
  'youtube',
  'snapchat',
  'tiktok',
  'pinterest',
  'vimeo',
  'tumblr',
  'patreon',
  'linkedin',
];

/*
 * Sort social media accounts based on enabledSocialPlatforms list
 */
export const sortSocialMediaAccounts = (
  socialMediaAccounts: PublicPageQueryResultSocialMediaAccount[] = [],
) => {
  if (socialMediaAccounts.length > 0)
    return [...socialMediaAccounts].sort(
      (socialA, socialB) =>
        enabledSocialPlatforms.indexOf(socialA.network) -
        enabledSocialPlatforms.indexOf(socialB.network),
    );
  else return [...socialMediaAccounts];
};

/*
 * Create social media urls from network and handle information
 */
export const socialMediaUrl = (network: string, handle: string) => {
  switch (network) {
    case 'email':
      return `mailto:${handle}`;
    case 'facebook':
      return `https://www.facebook.com/${handle}`;
    case 'twitter':
      return `https://www.twitter.com/${handle}`;
    case 'instagram':
      return `https://www.instagram.com/${handle}`;
    case 'youtube':
      return `https://www.youtube.com/${handle}`;
    case 'pinterest':
      return `https://www.pinterest.com/${handle}`;
    case 'snapchat':
      return `https://www.snapchat.com/add/${handle}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${handle}`;
    case 'patreon':
      return `https://www.patreon.com/${handle}`;
    case 'linkedin':
      if (
        handle.startsWith('company/') ||
        handle.startsWith('showcase/') ||
        handle.startsWith('in/')
      ) {
        return `https://www.linkedin.com/${handle}`;
      } else {
        return `https://www.linkedin.com/in/${handle}`;
      }
    case 'shop':
      return validateURL(handle);
    default:
      return validateURL(handle);
  }
};

const validateURL = (url: string) => {
  const newUrl = url.trim().replace(/\s/g, '');

  if (/^(:\/\/)/.test(newUrl)) {
    return `http${newUrl}`;
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `http://${newUrl}`;
  }

  return newUrl;
};
